var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2851 9H17.7302C12.2702 9 9.01514 12.255 9.01514 17.715V30.27C9.01514 35.73 12.2702 38.985 17.7302 38.985H30.2851C35.7451 38.985 39.0001 35.73 39.0001 30.27V17.715C39.0001 12.255 35.7451 9 30.2851 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2902 18.6891C30.0302 18.5691 28.8752 18.4941 27.7502 18.4191L27.6302 17.6991C27.5252 16.9791 27.3002 15.4941 25.0352 15.4941H22.9502C20.7152 15.4941 20.4752 16.9191 20.3552 17.6841L20.2352 18.3891C19.5902 18.4341 18.9602 18.4641 18.3152 18.5241L16.6802 18.6891C16.1102 18.7491 15.7052 19.2441 15.7652 19.8141C15.8252 20.3391 16.2602 20.7441 16.7852 20.7441C16.8152 20.7441 16.8602 20.7441 16.8902 20.7441L18.5102 20.5791C19.4102 20.5041 20.3252 20.4291 21.2252 20.3841C23.0552 20.3091 24.8852 20.3391 26.7302 20.4291C28.0952 20.4891 29.5202 20.5941 31.0802 20.7441C31.1102 20.7441 31.1402 20.7441 31.1702 20.7441C31.6952 20.7441 32.1452 20.3391 32.1902 19.8141C32.2652 19.2441 31.8602 18.7341 31.2902 18.6891Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7448 22.6498C29.4898 22.3648 29.1148 22.2148 28.7398 22.2148H19.2598C18.8848 22.2148 18.5098 22.3798 18.2548 22.6498C17.9998 22.9348 17.8648 23.3098 17.8948 23.6848L18.3598 29.6248C18.4498 30.8998 18.5548 32.4898 21.4348 32.4898H26.5648C29.4448 32.4898 29.5498 30.8998 29.6398 29.6248L30.1048 23.6848C30.1348 23.3098 29.9998 22.9348 29.7448 22.6498Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSquare);
export default __webpack_public_path__ + "static/media/trashSquare.150e86ee3f6afd4de57d3d90530034f1.svg";
export { ForwardRef as ReactComponent };